<template>
  <b-overlay
    :show="show"
    variant="transparent"
    opacity="0.99"
    blur="5px"
    rounded="sm"
  >
    <template #overlay>
      <div class="text-center">
        <b-icon-controller
          font-scale="3"
          animation="cylon"
        />
        <p id="cancel-label">
          กรุณารอสักครู่...
        </p>
      </div>
    </template>
    <div class="card">
      <div class="card-body">
        <div>
          <h2 class="text-dark font-medium-3">
            <i class="fa fa-search" /> ค้นหา
          </h2>
        </div>
        <div class="row">
          <div class="col-md-1">
            <div class="form-group">
              <label for="username">สกุลเงิน</label>
              <b-form-select
                v-model="currency"
                :options="currencyOPs"
                placeholder="เลือกสกุลเงิน"
                @input="getDeposit()"
              />
            </div>
            <label>รีเฟรช ออโต้</label>
            <div class="col-md-2">
              <b-form-checkbox
                v-model="status_interval"
                checked="true"
                class="custom-control-info"
                name="check-button"
                switch
              >
                <span class="switch-icon-left">
                  <feather-icon icon="CheckIcon" />
                </span>
                <span class="switch-icon-right">
                  <feather-icon icon="XIcon" />
                </span>
              </b-form-checkbox>
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="username">บัญชีฝากเข้า</label>
              <b-form-select
                v-model="search_from"
                :options="bankdepOP"
                placeholder="บัญชีฝากเข้า"
                text-field="username"
                value-field="acc_number"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="username">Keyword</label>
              <input
                id="username"
                v-model="search_val"
                type="text"
                class="form-control"
                placeholder="ชื่อ เบอร์โทร ยูสเซอร์เนม"
                @keyup.enter="getDeposit()"
              >
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <label for="listadmin">ค้นหาแอดมิน</label>
              <b-form-select
                v-model="search_admin"
                :options="adminOPs"
                placeholder="เลือกแอดมิน"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="dateStart">วันที่เริ่มต้น</label>
              <flat-pickr
                v-model="dateStart"
                class="form-control"
                placeholder="เลือกเวลาเริ่มต้น"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }"
              />
            </div>
          </div>
          <div class="col-md-2">
            <div class="form-group">
              <label for="dateEnd">วันที่สิ้นสุด</label>
              <flat-pickr
                v-model="dateEnd"
                class="form-control"
                placeholder="เลือกเวลาสิ้นสุด"
                :config="{ enableTime: true, dateFormat: 'Y-m-d H:i', time_24hr: true }"
              />
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <label for="username">เรียงข้อมูลตาม</label>
              <b-form-select
                v-model="sort"
                :options="SortOP"
              />
            </div>
          </div>
          <div class="col-md-1">
            <div class="form-group">
              <label for="username">การจัดเรียง</label>
              <b-form-select
                v-model="sorttype"
                :options="SortOP2"
              />
            </div>
          </div>
          <!-- <div class="col-md-12">
            <div class="form-group">
              <label for="username">เลือกธนาคาร</label>
              <b-form-select
                v-model="search_from"
                :options="fromOPs"
                placeholder="เลือกธนาคาร"
              />
            </div>
          </div> -->
          <div class="col-md-1 mt-2">
            <button
              class="btn btn-gradient-dark"
              @click="getDeposit()"
            >
              <feather-icon icon="SearchIcon" />
              ค้นหา
            </button>
          </div>
        </div>
      </div>
    </div>
    <b-card
      no-body
    >
      <b-card-body>
        <div class="d-flex flex-wrap">
          <b-form-group
            class="mr-1 mb-md-0"
          >
            <b-button
              v-b-modal.modal-1
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-primary"
              block
              @click="addData"
            >
              เติมเครดิต
            </b-button>
          </b-form-group>
          <b-form-group
            v-if="UserData.agent_id == 2"
            class="mr-1 mb-md-0"
          >
            <b-button
              v-b-modal.modal-3
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-danger"
              @click="search = false, tel = null , member = null"
            >
              ตัดเครดิตทั้งหมด
            </b-button>
          </b-form-group>
          <!-- <b-form-group
            class="mr-1 mb-md-0"
          >
            <b-button
              v-b-modal.modal-2
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-warning"
              block
              @click="tel = '',search = false"
            >
              แจกโบนัส
            </b-button>
          </b-form-group> -->
          <b-form-group
            class="mr-1 mb-md-0"
          >
            <b-button
              v-b-modal.modal-4
              v-ripple.400="'rgba(113, 102, 240, 0.15)'"
              variant="gradient-success"
              block
              @click="tel = '',qrCodeResult=null,autoSlipAcc=null,search = false,qrCodeStatus = true"
            >
              เติมเครดิตด้วยสลิป
            </b-button>
          </b-form-group>
          <button
            v-b-modal.exportDepositModal
            class="btn btn-warning ml-1"
          >
            Export
          </button>
          <b-modal
            id="exportDepositModal"
            title="ระบุรหัสผ่าน"
            @ok="checkExportPassword"
          >
            <b-form-input v-model="exportPassword" />
          </b-modal>
        </div>
      </b-card-body>
      <b-table
        small
        striped
        hover
        responsive
        show-empty
        class="position-relative items-center"
        :per-page="perPage"
        :items="items"
        :fields="fields"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        :filter="filter"
        :filter-included-fields="filterOn"
        @sort-changed="getDeposit"
      >
        <template #cell(index)="data">
          {{ perPage * (currentPage - 1) + (data.index + 1) }}
        </template>
        <template #empty="scope">
          <div class="p-2 text-center">
            <img
              src="/box.png"
              alt="empty"
              height="40px"
            > {{ scope.emptyFiltered ? 'No matching records found' : 'ไม่พบข้อมูล' }}
          </div>
        </template>
        <template #cell(picture)="data">
          <b-avatar
            size="lg"
            :src="data.item.picture"
          />
        </template>
        <template #cell(currencyshow)>
          {{ currency === 'THB' ? 'บาท' : 'KRW' }}
        </template>
        <template #cell(before_balance)="data">
          {{ data.item.before_balance ? Commas(data.item.before_balance.toFixed(2)) : 0.00 }}
        </template>
        <template #cell(balance)="data">
          <p class="font-weight-bolder text-success mb-0">
            {{ data.item.balance ? Commas(data.item.balance.toFixed(2)) : 0.00 }}
          </p>
        </template>
        <template #cell(amount)="data">
          <p class="font-weight-bolder text-warning mb-0">
            {{ data.item.amount ? Commas(data.item.amount.toFixed(2)) : 0.00 }}
          </p>
        </template>
        <template #cell(bonus)="data">
          {{ data.item.bonus.toFixed(2) }}
        </template>
        <template #cell(ip)="data">
          <div class="text-nowrap">
            <a
              :href="`http://${data.item.ip}`"
              target="_blank"
            >{{ data.item.ip }}</a>

          </div>
        </template>
        <template #cell(username)="data">
          <span
            v-if="data.item.blacklist"
            style="color:red"
          >
            {{ data.item.username }}
          </span>
          <span
            v-else-if="data.item.vip"
            style="color: blue"
          >
            {{ data.item.username }}
          </span>
          <span v-else>
            {{ data.item.username }}
          </span>
        </template>
        <template #cell(fullname)="data">
          <span
            v-if="data.item.blacklist"
            style="color:red"
          >
            {{ data.item.fullname }}
          </span>
          <span
            v-else-if="data.item.vip"
            style="color:blue"
          >
            {{ data.item.fullname }}
          </span>
          <span v-else>
            {{ data.item.fullname }}
          </span>
        </template>
        <!-- Column: Detail -->
        <template #cell(detail)="data">
          <div class="text-nowrap">
            <b-button
              v-b-tooltip.hover.v-info
              title="รายละเอียด"
              variant="gradient-info"
              size="sm"
              @click="$router.push({ name: 'Deposit-Withdraw', params: { id: data.item.username }})"
            >
              <i class="fas fa-address-card" />
            </b-button>
            <!-- <feather-icon
              :id="`invoice-row-${data.item.id}-preview-icon`"
              icon="FileTextIcon"
              size="16"
              class="mx-1"
              @click="$router.push({ name: 'Deposit-Withdraw', params: { id: data.item.username }})"
            /> -->
            <!-- <b-tooltip
              title="History Deposit & Withdraw"
              :target="`invoice-row-${data.item.username}-preview-icon`"
            /> -->
          </div>
        </template>
        <template #cell(status)="data">
          <div class="text-nowrap">
            <b-badge
              v-if="data.item.status === 'cancel'"
              variant="light-danger"
            >
              {{ data.item.status }}
            </b-badge>
            <b-badge
              v-if="data.item.status === 'waiting'"
              variant="light-warning"
            >
              {{ data.item.status }}
            </b-badge>
            <b-badge
              v-if="data.item.status === 'success'"
              variant="light-success"
            >
              {{ data.item.status }}
            </b-badge>
          </div>
        </template>
        <!-- Column: Actions -->
        <template #cell(actions)="data">
          <div class="text-nowrap">
            <b-badge
              v-if="data.item.status !== 'cancel'"
              variant="light-primary"
              @click="CancelList(data.item)"
            >
              ยกเลิกรายการ
            </b-badge>

          </div>
        </template>
        <!-- จากบัญชี / ฝากเข้าบัญชี -->
        <template #cell(frome)="data">
          <div>
            <div class="text-center">
              <img
                v-if="data.item.bank === 'kbank'"
                :src="`/bankIcon/KBANK.png`"
                alt="bank"
                class="bank-icon"
                :style="`background:#009345;`"
              >
              <img
                v-else-if="data.item.bank === 'ktb'"
                :src="`/bankIcon/KTB.png`"
                alt="bank"
                class="bank-icon"
              >
              <img
                v-else-if="data.item.bank === 'krungsri'"
                :src="`/bankIcon/BAY.png`"
                alt="bank"
                class="bank-icon"
                :style="`background:#6F5F60;`"
              >
              <img
                v-else-if="data.item.bank === 'scb'"
                :src="`/bankIcon/scb.png`"
                alt="bank"
                class="bank-icon"
                :style="`background:#4c2786;`"
              >
              <img
                v-else-if="data.item.bank === 'payment'"
                :src="`/bankIcon/payment.png`"
                alt="bank"
                class="bank-icon"
                :style="`background:#ffffff;`"
              >
              <img
                v-else-if="data.item.bank === 'truewallet'"
                :src="`/bankIcon/true.svg`"
                alt="bank"
                class="bank-icon"
                :style="`background:#ffffff;`"
              >
              <img
                v-else-if="data.item.bank === 'hana'"
                :src="`/bankIcon/hana.webp`"
                alt="bank"
                class="bank-icon"
                :style="`background:#ffffff;`"
              >
              <img
                v-else-if="data.item.bank === 'autopeer' || data.item.bank === 'autopeer-mbet'"
                :src="`/bankIcon/autopeer.png`"
                alt="AutoPeer"
                class="bank-icon"
                :style="`background:#ffffff;`"
              >
              <img
                v-else-if="data.item.agent_bank_pathphoto"
                :src="`/bankIcon/${data.item.agent_bank_pathphoto}`"
                alt="bank"
                class="bank-icon"
                :style="`background: ${data.item.bank_bg ? data.item.bank_bg : '#fff'};`"
              >
              <br>
              <template v-if="data.item.bank === 'autopeer' || data.item.bank === 'autopeer-mbet'">
                <small>{{ data.item.agent_bankname || 'AutoPeer' }}</small>
              </template>
              <template v-else>
                <small class="text-info"><u>{{ data.item.agent_acc_no }}</u></small>
                <template v-if="data.item.agent_acc_no">
                  <br>
                </template>
                <small>{{ data.item.agent_acc_name }}</small>
              </template>
            </div>
          </div>
        </template>
      </b-table>

      <b-card-body class="d-flex justify-content-between flex-wrap pt-0">

        <!-- page length -->
        <b-form-group
          label="Per Page"
          label-cols="8"
          label-align="left"
          label-size="sm"
          label-for="sortBySelect"
          class="text-nowrap mb-md-0 mr-1"
        >
          <b-form-select
            id="perPageSelect"
            v-model="perPage"
            size="sm"
            inline
            :options="pageOptions"
            @change="getDeposit()"
          />
        </b-form-group>

        <!-- pagination -->
        <div>
          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            first-number
            last-number
            prev-class="prev-item"
            next-class="next-item"
            class="mb-0"
            @input="getDeposit()"
          >
            <template #prev-text>
              <feather-icon
                icon="ChevronLeftIcon"
                size="18"
              />
            </template>
            <template #next-text>
              <feather-icon
                icon="ChevronRightIcon"
                size="18"
              />
            </template>
          </b-pagination>
        </div>
      </b-card-body>
      <b-modal
        id="modal-1"
        title="เติมเครดิต"
        ok-title="เติมเครดิต"
        @ok="submit"
      >
        <b-overlay
          :show="show2"
          variant="transparent"
          opacity="0.99"
          blur="5px"
          rounded="sm"
        >
          <template #overlay>
            <div class="text-center">
              <b-icon-controller
                font-scale="3"
                animation="cylon"
              />
              <p id="cancel-label">
                กรุณารอสักครู่...
              </p>
            </div>
          </template>
          <validation-observer ref="simpleRules">
            <div class="d-flex">
              <b-form-input
                id="vi-first-name"
                v-model="tel"
                class="col-9 mr-1"
                name="tel"
                type="number"
                placeholder="กรอกเบอร์โทรศัพท์แล้วกดค้นหา"
              />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="col-2.5 btn-icon"
                block
                @click="getUsersSearch()"
              >
                <feather-icon icon="SearchIcon" />
                ค้นหา
              </b-button>
            </div>
            <div>
              <span
                v-if="!member && search === true"
                style="color :red;"
              >
                ไม่พบข้อมูล
              </span>
              <span
                v-if="member && search === true"
                style="color :green;"
              >
                {{ member.name }} {{ member.surname }} : {{ member.username }}
              </span>
            </div>
            <div class="row">
              <div
                v-if="currency === 'THB'"
                class="col-8"
              >
                <b-form-group
                  label="จำนวนเงิน"
                  label-for="vi-first-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="amount"
                    :rules="`required|between:1,${MaxAmount}`"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <i class="fad fa-donate" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        v-model="amount"
                        name="amount"
                        type="number"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0]? `กรุณากรอกจำนวนเงิน 1-${MaxAmount}` : '' }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div
                v-else
                class="col-8"
              >
                <b-form-group
                  label="จำนวนเงิน"
                  label-for="vi-first-name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="amount"
                    :rules="`required|between:1,${MaxAmountKr}`"
                  >
                    <b-input-group class="input-group-merge">
                      <b-input-group-prepend is-text>
                        <i class="fad fa-donate" />
                      </b-input-group-prepend>
                      <b-form-input
                        id="vi-first-name"
                        v-model="amount"
                        name="amount"
                        type="number"
                        :state="errors.length > 0 ? false:null"
                        placeholder=""
                      />
                    </b-input-group>
                    <small class="text-danger">{{ errors[0]? `กรุณากรอกจำนวนเงิน 1-${MaxAmountKr}` : '' }}</small>
                  </validation-provider>
                </b-form-group>
              </div>
              <div class="col-4">
                <div>
                  <label for="from">สกุลเงิน</label>
                  <div>
                    <b-form-select
                      v-model="currency"
                      :options="currencyOPs"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <label for="dateslip">วันที่ (สลิป)</label>
                <flat-pickr
                  v-model="dateslip"
                  class="form-control"
                />
              </div>
              <div class="col">
                <label for="time">เวลา (สลิป)</label>
                <div class="d-flex align-items-center">
                  <b-form-select
                    v-model="time"
                    :options="timeOp1"
                    style="width: 80px"
                  />
                  <span style="margin-left: 5px; margin-right: 5px">:</span>
                  <b-form-select
                    v-model="time2"
                    :options="timeOp2"
                    style="width: 80px"
                  />
                </div>
              </div>
              <div class="col">
                <div>
                  <label for="from">เลือกบัญชีที่ฝากเข้า</label>
                  <div>
                    <b-form-select
                      v-model="bankdep"
                      :options="bankdepOP"
                      text-field="username"
                      value-field="acc_number"
                    />
                  </div>
                </div>
              </div>
            </div>

          </validation-observer>
        </b-overlay>
      </b-modal>
      <b-modal
        id="modal-2"
        title="แจกโบนัสลูกค้า"
        ok-title="แจกโบนัส"
        @ok="submitbonus"
      >
        <validation-observer ref="simpleRules">
          <b-form-group>
            <div class="d-flex">
              <b-form-input
                id="vi-first-name"
                v-model="tel"
                class="col-9 mr-1"
                name="tel"
                type="number"
                placeholder="กรอกเบอร์โทรศัพท์แล้วกดค้นหา"
              />
              <b-button
                v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                variant="primary"
                class="col-2.5 btn-icon"
                block
                @click="getUsersSearch()"
              >
                <feather-icon icon="SearchIcon" />
                ค้นหา
              </b-button>
            </div>
            <div>
              <span
                v-if="!member && search === true"
                style="color :red;"
              >
                ไม่พบข้อมูล
              </span>
              <span
                v-if="member && search === true"
                style="color :green;"
              >
                {{ member.name }} {{ member.surname }} : {{ member.username }}
              </span>
            </div>
          </b-form-group>
          <div class="row">
            <div class="col-8">
              <b-form-group
                label="โบนัส"
                label-for="vi-first-name"
              >
                <validation-provider
                  #default="{ errors }"
                  name="bonus"
                  rules="required"
                >
                  <b-input-group class="input-group-merge">
                    <b-input-group-prepend is-text>
                      <i class="fad fa-donate" />
                    </b-input-group-prepend>
                    <b-form-input
                      id="vi-first-name"
                      v-model="bonus"
                      name="bonus"
                      type="number"
                      :state="errors.length > 0 ? false:null"
                      placeholder=""
                    />
                  </b-input-group>
                </validation-provider>
              </b-form-group>
            </div>
            <div class="col-4">
              <div>
                <label for="from">สกุลเงิน</label>
                <div>
                  <b-form-select
                    v-model="currency"
                    :options="currencyOPs"
                  />
                </div>
              </div>
            </div>
          </div>
          <b-form-group
            label="เทิร์นที่ลูกค้าต้องทำ"
            label-for="vi-first-name"
          >
            <validation-provider
              #default="{ errors }"
              name="turnover"
              rules="required|between:1,99999"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fad fa-donate" />
                </b-input-group-prepend>
                <b-form-input
                  id="vi-first-name"
                  v-model="turnover"
                  name="turnover"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  placeholder=""
                />
              </b-input-group>
              <small class="text-danger">{{ errors[0]? `ขั้นต่ำ 1` : '' }}</small>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="ยอดเงินที่ลูกค้าถอนได้สูงสุด"
            label-for="vi-first-name"
          >
            <validation-provider
              #default="{ errors }"
              name="maxamount"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <b-input-group-prepend is-text>
                  <i class="fad fa-donate" />
                </b-input-group-prepend>
                <b-form-input
                  id="vi-first-name"
                  v-model="maxamount"
                  name="maxamount"
                  type="number"
                  :state="errors.length > 0 ? false:null"
                  placeholder=""
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
          <b-form-group
            label="หมายเหตุ"
            label-for="vi-first-name"
          >
            <validation-provider
              #default="{ errors }"
              name="bonus"
              rules="required"
            >
              <b-input-group class="input-group-merge">
                <!-- <b-input-group-prepend is-text>
                  <i class="fad fa-donate" />
                </b-input-group-prepend> -->
                <b-form-input
                  id="vi-first-name"
                  v-model="remark"
                  name="remark"
                  type="textarea"
                  :state="errors.length > 0 ? false:null"
                  placeholder=""
                />
              </b-input-group>
            </validation-provider>
          </b-form-group>
        </validation-observer>
      </b-modal>
      <b-modal
        id="modal-3"
        title="ตัดเครดิตทั้งหมด"
        ok-title="ตัดเครดิต"
        @ok="submitHold"
      >
        <b-overlay
          :show="show2"
          variant="transparent"
          opacity="0.99"
          blur="5px"
          rounded="sm"
        >
          <template #overlay>
            <div class="text-center">
              <b-icon-controller
                font-scale="3"
                animation="cylon"
              />
              <p id="cancel-label">
                กรุณารอสักครู่...
              </p>
            </div>
          </template>
          <b-form-group>
            <div class="row">
              <div class="col-3">
                <div>
                  <label for="from">สกุลเงิน</label>
                  <div>
                    <b-form-select
                      v-model="currency"
                      :options="currencyOPs"
                    />
                  </div>
                </div>
              </div>
              <div class="col-6">
                <label for="from" />
                <b-form-input
                  id="vi-first-name"
                  v-model="tel"
                  name="tel"
                  type="number"
                  placeholder="กรอกเบอร์โทรศัพท์แล้วกดค้นหา"
                />
              </div>
              <div class="col-3">
                <label for="from" />
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  block
                  @click="getUsersSearch()"
                >
                  <feather-icon icon="SearchIcon" />
                  ค้นหา
                </b-button>
              </div>
            </div>
            <br>
            <div>
              <span
                v-if="!member && search === true"
                style="color :red;"
              >
                ไม่พบข้อมูล
              </span>
              <span
                v-if="member && search === true"
                style="color :green;"
              >
                {{ member.name }} {{ member.surname }} : {{ member.username }}
              </span>
            </div>
            <br>
            <!-- <b-form-group
              label="จำนวนเงินที่ต้องการยึด"
              label-for="vi-first-name"
            >

              <b-form-input
                id="vi-first-name"
                v-model="amount"
                placeholder=""
              />

            </b-form-group> -->
          </b-form-group>
        </b-overlay>
      </b-modal>
      <b-modal
        id="modal-4"
        title="เติมเครดิตด้วยสลิป"
        ok-title="ยืนยัน"
        @ok="submitAutoSlip"
      >
        <b-overlay
          :show="show2"
          variant="transparent"
          opacity="0.99"
          blur="5px"
          rounded="sm"
        >
          <template #overlay>
            <div class="text-center">
              <b-icon-controller
                font-scale="3"
                animation="cylon"
              />
              <p id="cancel-label">
                กรุณารอสักครู่...
              </p>
            </div>
          </template>
          <b-form-group>
            <div class="row">
              <div class="col-12">
                <label for="from">เลือกบัญชีที่ฝากเข้า</label>
                <b-form-select
                  v-model="autoSlipAcc"
                  :options="autoSlipBank"
                  text-field="show_text"
                  value-field="acc_number"
                />
              </div>
              <div class="col-9">
                <label for="from" />
                <b-form-input
                  id="vi-first-name"
                  v-model="tel"
                  name="tel"
                  type="number"
                  placeholder="กรอกเบอร์โทรศัพท์แล้วกดค้นหา"
                />
              </div>
              <div class="col-3">
                <label for="from" />
                <b-button
                  v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                  variant="primary"
                  block
                  @click="getUsersSearch()"
                >
                  <feather-icon icon="SearchIcon" />
                  ค้นหา
                </b-button>
              </div>
            </div>
            <div>
              <span
                v-if="!member && search === true"
                style="color :red;"
              >
                ไม่พบข้อมูล
              </span>
              <span
                v-if="member && search === true"
                style="color :green;"
              >
                {{ member.name }} {{ member.surname }} : {{ member.username }}
              </span>
              <div v-if="member && search === true && autoSlipAcc">
                <b-form-group
                  label="เลือกสลิป"
                  label-for="image_link"
                >
                  <b-form-file
                    placeholder="เลือกไฟล์รูปภาพ..."
                    accept="image/*"
                    @change="onFileChange"
                  />
                </b-form-group>
                <span
                  v-if="!qrCodeStatus"
                  style="color :red;"
                >
                  ไม่พบQrCode
                  <b-form-input
                    id="vi-first-qrCodeResult"
                    v-model="qrCodeResult"
                    placeholder="กรอกข้อมูลจาก Qrcode"
                  />
                </span>
              </div>
            </div>
            <br>
          </b-form-group>
        </b-overlay>
      </b-modal>
    </b-card>
  </b-overlay>
</template>

<script>
// import vSelect from 'vue-select'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import moment from 'moment-timezone'
import {
  BBadge,
  BFormFile,
  BFormCheckbox,
  // BRow,
  // BCol,
  BOverlay, BIconController, BInputGroupPrepend, BModal, BCard, BTable, BAvatar, BFormGroup, BFormSelect, BPagination, BInputGroup, BFormInput, BButton, BCardBody, VBToggle,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import { required, email } from '@validations'
import flatPickr from 'vue-flatpickr-component'
import jsQR from 'jsqr'

export default {
  components: {
    BFormCheckbox,
    flatPickr,
    // BRow,
    BFormFile,
    BBadge,
    // BCol,
    // vSelect,
    BInputGroupPrepend,
    BModal,
    BCard,
    BTable,
    BAvatar,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    // BInputGroupAppend,
    BButton,
    BCardBody,
    BOverlay,
    BIconController,
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
    'b-toggle': VBToggle,
  },
  data() {
    return {
      search_type_option: [
        { value: 1, text: 'ยูสเซอร์เนม' },
        { value: 2, text: 'เบอร์โทร' },
      ],
      search_type: null,
      search_val: null,
      emailValue: '',
      time: null,
      time2: null,
      from: null,
      name: '',
      required,
      email,
      show: true,
      depositdata: [],
      member: '',
      amount: '',
      optionsMember: '',
      perPage: 20,
      pageOptions: [10, 15, 20, 50, 100],
      totalRows: 1,
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      usersList: [],
      datasidebar: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: '',
      },
      fromOP: [
        { value: 'scb', text: 'ธนาคารไทยพาณิชย์' },
        { value: 'kbank', text: 'ธนาคารกสิกรไทย' },
        { value: 'truewallet', text: 'truewallet' },
        { value: 'krunsri', text: 'ธนาคารกรุงศรีอยุธยา' },
        { value: 'hana', text: 'ธนาคารเกาหลี' },
      ],
      timeOp1: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },

      ],
      timeOp2: [
        { value: '00', text: '00' }, { value: '01', text: '01' },
        { value: '02', text: '02' }, { value: '03', text: '03' },
        { value: '04', text: '04' }, { value: '05', text: '05' },
        { value: '06', text: '06' }, { value: '07', text: '07' },
        { value: '08', text: '08' }, { value: '09', text: '09' },
        { value: '10', text: '10' }, { value: '11', text: '11' },
        { value: '12', text: '12' }, { value: '13', text: '13' },
        { value: '14', text: '14' }, { value: '15', text: '15' },
        { value: '16', text: '16' }, { value: '17', text: '17' },
        { value: '18', text: '18' }, { value: '19', text: '19' },
        { value: '20', text: '20' }, { value: '21', text: '21' },
        { value: '22', text: '22' }, { value: '23', text: '23' },
        { value: '24', text: '24' }, { value: '25', text: '25' },
        { value: '26', text: '26' }, { value: '27', text: '27' },
        { value: '28', text: '28' }, { value: '29', text: '29' },
        { value: '30', text: '30' }, { value: '31', text: '31' },
        { value: '32', text: '32' }, { value: '33', text: '33' },
        { value: '34', text: '34' }, { value: '35', text: '35' },
        { value: '36', text: '36' }, { value: '37', text: '37' },
        { value: '38', text: '38' }, { value: '39', text: '39' },
        { value: '40', text: '40' }, { value: '41', text: '41' },
        { value: '42', text: '42' }, { value: '43', text: '43' },
        { value: '44', text: '44' }, { value: '45', text: '45' },
        { value: '46', text: '46' }, { value: '47', text: '47' },
        { value: '48', text: '48' }, { value: '49', text: '49' },
        { value: '50', text: '50' }, { value: '51', text: '51' },
        { value: '52', text: '52' }, { value: '53', text: '53' },
        { value: '54', text: '54' }, { value: '55', text: '55' },
        { value: '56', text: '56' }, { value: '57', text: '57' },
        { value: '58', text: '58' }, { value: '59', text: '59' },

      ],
      fields: [
        { key: 'index', label: 'no.' },
        // { key: 'detail', label: 'รายละเอียดลูกค้า' },
        { key: 'frome', label: 'ฝากเข้าบัญชี' },
        { key: 'username', label: 'ยูสเซอร์เนม' },
        { key: 'tel', label: 'เบอร์โทร' },
        { key: 'fullname', label: 'ชื่อลูกค้า' },
        { key: 'invited_by_name', label: 'ผู้แนะนำ' },
        { key: 'dateslip', label: 'วันที่ในสลิป' },
        { key: 'time', label: 'เวลาในสลิป', sortable: true },
        { key: 'before_balance', label: 'ก่อนฝาก' },
        { key: 'amount', label: 'จำนวนเงินฝาก', sortable: true },
        { key: 'bonus', label: 'โบนัส', sortable: true },
        { key: 'balance', label: 'ยอดเครดิตรวม', sortable: true },
        { key: 'currencyshow', label: 'สกุลเงิน', sortable: true },
        { key: 'addbyName', label: 'ฝากเงินโดย' },
        { key: 'bank', label: 'ธนาคาร' },
        { key: 'from', label: 'ที่มา' },
        { key: 'status', label: 'status' },
        {
          key: 'created_at',
          label: 'เวลา',
          formatter: value => moment(value)
            .tz('Asia/Bangkok')
            .format('DD/MM/YYYY HH:mm:ss'),
        },
        { key: 'actions', label: 'Actions' },

      ],
      /* eslint-disable global-require */
      items: [],
      addNewDataSidebar: false,
      UserData: JSON.parse(localStorage.getItem('userData')),
      show2: false,
      tel: null,
      search: false,
      dateStart: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 00:00:00'),
      dateEnd: moment().tz('Asia/Bangkok').format('YYYY-MM-DD 23:59:59'),
      dateslip: moment().tz('Asia/Bangkok').format('YYYY-MM-DD'),
      fromOPs: [
        { value: null, text: 'ทั้งหมด' },
        { value: 'scb', text: 'ธนาคารไทยพาณิชย์' },
        { value: 'kbank', text: 'ธนาคารกสิกรไทย' },
        { value: 'truewallet', text: 'truewallet' },
        { value: 'hana', text: 'ธนาคารเกาหลี' },
        { value: 'bonus', text: 'โบนัส' },
      ],
      adminOPs: [],
      search_from: null,
      search_admin: null,
      MaxAmount: 0,
      MaxAmountKr: 0,
      URLs: null,
      URLbonus: null,
      currency: 'THB',
      currencyOPs: ['THB', 'KRW'],
      qrCodeResult: null,
      qrCodeStatus: true,
      autoSlipBank: [],
      autoSlipAcc: null,
      bankdepOP: [],
      bankdep: null,
      status_interval: false,
      exportPassword: '',
      SortOP: [
        { value: 'time', text: 'เวลาสลิป' },
        { value: 'amount', text: 'จำนวนเงินฝาก' },
        { value: 'bonus', text: 'โบนัส' },
      ],
      SortOP2: [
        { value: 'asc', text: 'น้อย -> มาก' },
        { value: 'desc', text: 'มาก -> น้อย' },
      ],
      sort: null,
      sorttype: null,
    }
  },
  computed: {
    agent() {
      return this.$store.state.app.agent
    },
    role() {
      return this.$store.state.app.role
    },
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }))
    },
  },
  created() {
    this.interval = setInterval(() => {
      if (this.status_interval) {
        this.getDeposit()
      }
    }, 60000)
  },
  destroyed() {
    clearInterval(this.interval)
  },
  mounted() {
    this.totalRows = this.items.length
    this.getDeposit()
    this.getAgent()
    this.getAdminlist()
    this.getAutoSlipBank()
    this.GetBankDep()
  },
  methods: {
    GetBankDep() {
      this.$http
        .get('/bank/list/new')
        .then(response => {
          this.bankdepOP = response.data
        })
        .catch(error => console.log(error))
    },
    async submitAutoSlip() {
      if (!this.autoSlipAcc || !this.member || this.qrCodeResult === '' || !this.qrCodeResult) {
        this.SwalError('ข้อมูลไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง')
        return
      }
      this.show = true
      try {
        const obj = {
          code: this.qrCodeResult,
          account_number: this.autoSlipAcc,
          username: this.member.username,
        }
        const { data: res } = await this.$http.post('/scb/adminvelifyslip', obj)
        console.log(res)
        if (res.success) {
          this.Success(res.mes)
        } else {
          this.SwalError(res.mes)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.show = false
      }
    },
    onFileChange(event) {
      const file = event.target.files[0]
      const reader = new FileReader()

      reader.onload = e => {
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          const canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          const ctx = canvas.getContext('2d')
          ctx.drawImage(image, 0, 0)

          const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
          const qrCode = jsQR(imageData.data, canvas.width, canvas.height)

          if (qrCode) {
            this.qrCodeResult = qrCode.data
            this.qrCodeStatus = true
          } else {
            this.qrCodeResult = ''
            this.qrCodeStatus = false
          }
        }
      }

      if (file) {
        reader.readAsDataURL(file)
      }
    },
    getAutoSlipBank() {
      this.$http
        .get('/autoslip/banklist')
        .then(response => {
          if (response.data.success) {
            this.autoSlipBank = response.data.bank
          }
        })
        .catch(error => console.log(error))
    },
    getAdminlist() {
      this.$http
        .get('/admin/list')
        .then(response => {
          this.adminOPs = response.data
        })
        .catch(error => console.log(error))
    },
    submitHold() {
      if (this.member) {
        this.show = true
        const formData = {
          username: this.member.username,
          uid: this.member.id,
          currency: this.currency,
        }
        this.$http
          .post('/withdraw/holdstore/all', formData)
          .then(() => {
            this.show = false
            this.getDeposit()
            this.username = ''
            this.amount = ''
            this.Success('ตัดเครดิตสำเร็จ')
          })
          .catch(error => {
            this.show = false
            this.SwalError(error.response.data.message)
          })
      } else {
        this.SwalError('กดค้นหายูสลูกค้าก่อนค่ะ !!')
        this.$refs['modal-2'].show()
      }
    },
    submitbonus() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.bonus && this.turnover && this.maxamount) {
            if (this.currency === 'THB') {
              this.URLbonus = '/deposit/storebonus'
            } else {
              this.URLbonus = '/deposit/storebonus/kr'
            }
            this.show = true
            const formData = {
              username: this.member.username,
              // betflix_username: this.member.betflix_username,
              uid: this.member.id,
              bonus: this.bonus,
              turnover: this.turnover,
              maxamount: this.maxamount,
              remark: this.remark,
            }
            // console.log(formData)
            this.$http
              .post(this.URLbonus, formData)
              .then(() => {
                this.show = false
                this.getDeposit()
                this.turnover = null
                this.maxamount = null
                this.member = ''
                this.bonus = ''
                this.Success('แจกโบนัสสำเร็จ')
              })
              .catch(error => {
                this.show = false
                this.SwalError(error.response.data.message)
              })
          } else {
            this.show = false
            this.SwalError('กรุณาใส่ให้ครบทุกช่อง')
          }
        }
      })
    },
    getAgent() {
      this.$http
        .get('/agent/show')
        .then(response => {
          const AgData = response.data
          if (AgData.max_manual_dep_level1 && AgData.max_manual_dep_level2) {
            if (this.UserData.role === 'super admin') {
              this.MaxAmount = AgData.max_manual_dep_level2
              this.MaxAmountKr = AgData.max_manual_depkr_level2
            } else {
              this.MaxAmount = AgData.max_manual_dep_level1
              this.MaxAmountKr = AgData.max_manual_depkr_level1
            }
          }
        })
        .catch(error => console.log(error))
    },
    CancelList(data) {
      this.$swal({
        title: 'ยืนยันที่จะยกเลิกรายการฝาก ?',
        text: `ของ ${data.fullname ? data.fullname : data.username} จำนวน ${data.amount} ${this.currency === 'THB' ? 'บาท' : 'KRW'} หรือไม่ ?`,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          const obj = {
            data,
            currency: this.currency,
          }
          this.$http
            .post('/deposit/cancel', obj)
          // eslint-disable-next-line no-unused-vars
            .then(response => {
              this.getDeposit()
              this.Success('ยกเลิกรายการฝากสำเร็จ')
            })
            .catch(error => {
              this.SwalError(error.response.data.message)
            })
        } else {
          this.$swal('ยกเลิก', 'ยกเลิกคำสั่ง !', 'error')
        }
      })
    },
    getUsersSearch() {
      this.show2 = true
      const obj = {
        tel: this.tel,
      }
      this.$http
        .post('/users/search', obj)
        .then(response => {
          this.member = response.data
          this.search = true
          this.show2 = false
        })
        .catch(error => console.log(error))
    },
    info(item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal() {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    getUserslist() {
      this.$http
        .get('/users/list')
        .then(response => {
          this.show = false
          this.optionsMember = response.data
        })
        .catch(error => console.log(error))
    },
    getDeposit(ctx = {}) {
      this.items = []
      this.show = true
      if (this.currency === 'THB') {
        this.URLs = '/deposit/fromadmin'
      } else {
        this.URLs = '/deposit/fromadmin/krw'
      }
      // let index = 0
      const params = {
        page: this.currentPage,
        perPage: this.perPage,
        search_type: this.search_type,
        search_val: this.search_val,
        search_from: this.search_from,
        dateStart: this.dateStart,
        dateEnd: this.dateEnd,
        sortBy: ctx.sortBy ? ctx.sortBy : '',
        sortDesc: ctx.sortDesc ? ctx.sortDesc : '',
        search_admin: this.search_admin,
        sort: this.sort,
        sorttype: this.sorttype,
      }
      this.$http
        .get(this.URLs, { params })
        .then(response => {
          // console.log(response.data)
          this.show = false
          this.depositdata = response.data.data
          // this.depositdata.forEach(items => {
          //   this.getAdmin(items.addby, index)
          //   index += 1
          // })
          this.onFiltered(response.data)

          this.show = false
        })
        .catch(error => console.log(error))
    },
    getAdmin(addby, index) {
      this.$http
        .get(`/admin/show/${addby}`)
        .then(response => {
          this.show = false
          // console.log(response.data.name)
          this.depositdata[index].addby = response.data.name
        })
        .catch(error => console.log(error))
    },
    Commas(x) {
      if (!x) {
        return 0
      } if (x % 1 !== 0) {
        return Number(x).toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      }
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    submit() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          if (this.time && this.time2) {
            this.show = true
            const formData = {
              username: this.member.username,
              uid: this.member.id,
              amount: this.amount,
              dateslip: this.dateslip,
              time: `${this.time}:${this.time2}`,
              bank: this.from,
              currency: this.currency,
              bankdep: this.bankdep,
            }
            this.$http
              .post('/deposit/store', formData)
              .then(() => {
                this.show = false
                this.getDeposit()
                this.time = null
                this.time2 = null
                this.member = ''
                this.amount = ''
                this.from = null
                this.bankdep = null
                this.Success('เติมเครดิต สำเร็จ')
              })
              .catch(error => {
                this.show = false
                this.time = null
                this.time2 = null
                this.member = ''
                this.amount = ''
                this.from = null
                this.SwalError(error.response.data.message)
              })
          } else {
            this.show = false
            this.SwalError('กรุณาใส่ให้ครบทุกช่อง')
          }
        } else {
          this.show = false
          this.SwalError('กรุณากรอกข้อมูลให้ครบถ้วนและถูกต้อง')
        }
      })
    },
    async checkExportPassword() {
      const obj = {
        password: this.exportPassword,
      }
      this.$http
        .post('/export/checkpass', obj)
        .then(response => {
          if (response.data.status === true) {
            this.exportData()
          } else {
            this.$swal({
              icon: 'error',
              title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
              text: 'รหัสผ่านไม่ถูกต้อง',
              customClass: {
                confirmButton: 'btn btn-primary',
              },
            })
          }
        })
        .catch(error => console.log(error))
    },
    async exportData() {
      try {
        const { data } = await this.$http.get('/export/deposits/byamin', {
          responseType: 'blob',
          params: {
            page: this.currentPage,
            perPage: this.perPage,
            search_type: this.search_type,
            search_val: this.search_val,
            search_from: this.search_from,
            search_admin: this.search_admin,
            dateStart: this.dateStart,
            dateEnd: this.dateEnd,
            currency: this.currency,
            sort: this.sort,
            sorttype: this.sorttype,
          },
        })

        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(
          new Blob([data]),
        )
        // link.setAttribute(`download', 'Export Deposit Date ${this.dateStart} - ${this.dateEnd}.xlsx`)
        link.setAttribute('download', 'รายการฝากโดยแอดมิน.xlsx')
        document.body.appendChild(link)
        link.click()
      } catch (error) {
        console.log(error)
      }
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.items = filteredItems.data
      this.totalRows = filteredItems.total
      // this.currentPage = 1
    },
    Get_userlist() {
      this.$http
        .get('/api/user/list')
        .then(response => {
          this.onFiltered(response.data.message)
        })
        .catch(error => console.log(error))
    },
    addData() {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = {}
      this.tel = null
      this.search = false
    },
    editData(data) {
      // this.sidebarData = JSON.parse(JSON.stringify(this.blankData))
      this.toggleDataSidebar(true)
      this.datasidebar = data
    },
    toggleDataSidebar(val = false) {
      this.addNewDataSidebar = val
    },
    Success(mes) {
      this.$swal({
        icon: 'success',
        title: '<h3 style="color: #141414">ทำรายการสำเร็จ</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-success',
        },
      })
    },
    SwalError(mes) {
      this.$swal({
        icon: 'error',
        title: '<h3 style="color: #141414">เกิดข้อผิดพลาด!</h3>',
        text: mes,
        customClass: {
          confirmButton: 'btn btn-primary',
        },
      })
    },
  },
}
</script>

<style scoped>
table {
  width: 100%;
  color: #fff !important;
}
thead, th, tr {
  color: #fff default;
}
.bank-icon {
    width: 35px;
    height: 35px;
    padding: 5px;
    border-radius: 50%;
  }
</style>

<style lang="scss" scoped>
@import "~@core/scss/base/pages/app-invoice.scss";

.form-item-section {
background-color:$product-details-bg;
}
th {
    color: #fff default;
    background-color: #000 !important;
}
</style>
<style lang="scss">
@import "@core/scss/vue/libs/vue-flatpicker.scss";
</style>
